export default __webpack_public_path__ + "static/media/p7-15.7e2226f0.png";